import { IClusteredPointSeriesSettings, IMapChartSettings } from '@amcharts/amcharts5/map';

export const needBulletLines = {
  'BR-RN': { dx: 10, dy: -30, rotation: 210 },
  'BR-PB': { dx: 50, dy: -16, rotation: 250 },
  'BR-PE': { dx: 56, dy: 0, rotation: 270 },
  'BR-AL': { dx: 30, dy: 14, rotation: 300 },
  'BR-SE': { dx: 20, dy: 30, rotation: 340 },
};

export const bulletOffsets: Record<string, { dx: number; dy: number }> = {
  'BR-RJ': { dx: 20, dy: 20 },
  'BR-ES': { dx: 28, dy: 0 },
  'BR-GO': { dx: -4, dy: 8 },
  ...needBulletLines,
};

export const bulletEmptyInfoPosition = { latitude: -28.788102, longitude: -65.556148 };

export const splittedPointSettings: Partial<IClusteredPointSeriesSettings> = {
  stopClusterZoom: 0.98,
  scatterDistance: 8,
  scatterRadius: 10,
};

export const defaultChartSettings: Partial<IMapChartSettings> = {
  panX: 'none',
  panY: 'none',
  wheelX: 'none',
  wheelY: 'none',
  wheelable: false,
  pinchZoom: false,
  maxPanOut: 0.3,
  minZoomLevel: 0,
  zoomStep: 1.5,
  maxZoomLevel: 100,
  dx: -5,
};
